import React from "react";
import { connect } from "react-redux";
import pt from "prop-types";
import BaseComponent from "meta/features/base-component";
import { Container } from "meta/ui2/layout";
import Iframe from "meta/ui2/iframe";
import ProgressBar from "meta/ui2/progress-bar";
import cn from "classnames";
import { progressStart, progressDone } from "../features/slices/rootSlice";
import { getMenuIdFromUrl } from "meta/utils/url";
import { patientDetailMenuId } from "../utils/constants";
import identifications from "screens/Root/utils/identifications";
import { bindActionCreators } from "redux";
import RightPanelFeatures from "../features/RightPanelFeatures/RightPanelFeatures";

class PageView extends BaseComponent {
  render() {
    let {
      id,
      url,
      frameSession,
      onRef,
      visible,
      active,
      onLoad,
      onWebEvent,
      onModalWebEvent,
      progress,
      progressStart,
      progressDone,
      style,
      refreshToken,
      visId,
      dockedActive,
      rightPanelExpanded,
    } = this.props;
    let { className } = this.props;

    const visIdParam =
      getMenuIdFromUrl(url).toLocaleLowerCase() === patientDetailMenuId
        ? "&visId=" + visId
        : "";
    let src;
    if (url) {
      src = `ContentTab/ContentTab.aspx?frameSession=${frameSession}&key=${id}&targetUrl=${encodeURIComponent(
        url
      )}${visIdParam}`;
    }
    else {
      // do not load ContentTab for empty URLs
      url = ''
    }
    return (
      <Container
        fit
        row
        visible={visible}
        className={cn(
          { "tab-container": true, active: active },
          className || {}
        )}
        data-frame-session={frameSession}
        style={style}
      >
        <RightPanelFeatures dockedActive={dockedActive} />
        <Container
          column
          flex="1 0 auto"
          className={cn(
            "content",
            !dockedActive || rightPanelExpanded ? "" : "hidden"
          )}
        >
          <Iframe
            key={id + refreshToken}
            name={id}
            data-active={active}
            data-docked-active={dockedActive}
            data-identification={identifications.contentTab(url)}
            src={src}
            onRef={onRef}
            onLoad={(_e, window) => onLoad(id, window.location.href)}
            onBeginRequest={() => progressStart(id)}
            onEndRequest={() => progressDone(id)}
            onWebEvent={onWebEvent}
            onModalWebEvent={onModalWebEvent}
          />
          <ProgressBar autoIncrement={true} percent={progress} />
        </Container>
      </Container>
    );
  }
}

PageView.propTypes = {
  url: pt.string,
  frameSession: pt.string,
  visible: pt.bool.isRequired,
  onLoad: pt.func,
  onWebEvent: pt.func,
  onRef: pt.func,
  progress: pt.number,
  style: pt.object,
};
PageView.defaultProps = {
  onLoad: () => {},
  onWebEvent: () => {},
  onRef: () => {},
  progress: -1,
  style: {},
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ progressStart, progressDone }, dispatch);
}

export default connect(null, mapDispatchToProps)(PageView);
